<template>
    <div class="step-card d-flex flex-column">
      <div class="step-card-header d-flex flex-row align-items-center">
        <div class="step-card-number">2</div>
        <div>
          <h3 class="mt-5">{{ $t('powersupplyGui.header') }}</h3>
          <p v-html="$t('powersupplyGui.description')"></p>
        </div>
      </div>

        <div class="step-card-body">
            <div class="position-relative">
                <div id="selectDeviceContainer" class="selectDeviceContainer">
                    <div class="selectedSystemCard" v-if="this.selectedSystem.image">
                        <img :src="getSystemPicture" />
                    </div>
                    <div class="selectedSystemCardIcon d-flex justify-content-center align-items-center" v-if="this.selectedSystem.id==1">
                        <i class="fa-kit fa-beg-logo-daco fa-6x" ></i>
                    </div>
                  <div class="selectedSystemCardIcon d-flex justify-content-center align-items-center" v-if="this.selectedSystem.id==3">
                    <i class="fa-kit fa-beg-casambi fa-6x" ></i>
                  </div>
                    <div class="selectedSystemCardIcon d-flex justify-content-center align-items-center" v-if="this.selectedSystem.id==4">
                        <i class="fa-kit fa-beg-logo-dali-link fa-6x" ></i>
                    </div>
                    <div class="selectedSystemCardIcon d-flex justify-content-center align-items-center" v-if="this.selectedSystem.id==5">
                        <i class="fa-kit fa-beg-logo-knx fa-6x" ></i>
                    </div>
                    <div class="selectedSystemCardIcon d-flex justify-content-center align-items-center" v-if="this.selectedSystem.id==6">
                        <i class="fa-kit fa-beg-bms-logo fa-6x" ></i>
                    </div>
                </div>
                <div v-if="!isCustomPowerSupplyAllowed">
                    <ImageDropdownTemplate :elements="dropdownItems"  />
                </div>
                <div id="customInputContainer" >
                    <template v-if="isCustomPowerSupplyAllowed">
                        <ApplicationControllerCardCustom :controller="customController" @selectCard="selectSystemCard" @onChange="isChanged"  />
                    </template>
                </div>
            </div>
        </div>

        {{ controller }}

    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import helper from '@/assets/js/helperTool';
import ApplicationControllerCardCustom from './ApplicationControllerCardCustom.vue'
import { ImageDropdownTemplate, ImageDropdownItem } from '@/begComponents/ImageDropdown';
//import { ImageDropdownTemplate, ImageDropdownItem } from '../../../../beg-layout/src/begComponents/ImageDropdown'

export default {
    name: "ApplicationControllerSelect",
    emits: ['onChange','onSelectedChange'],
    data() {
        return {
            dropdownIsOpen: false,
            previewNo: '93470',
            customDaliPower: 180,
            dropdownItems: [],
            controller: null
        }
    },
    mounted() {
        this.buildSelectableDevice();
    },
    methods: {
        selectSystemCard(controllerCard) {
            this.$store.dispatch('product/selectApplicationController',controllerCard)
            this.$emit('onSelectedChange', controllerCard)
        },
        isChanged() {
            this.$emit('onChange')
        },
        toggleDropdown() {
            this.dropdownIsOpen = !this.dropdownIsOpen;
            if(this.dropdownIsOpen === true) {
                    this.$refs.controllerResults.classList.add('openResults')
                    this.$refs.controllerResults.addEventListener("scroll", (event) => {
                    this.$refs.previewPicture.style.top =  (event.srcElement.scrollTop - 70) +"px";
                });
            } else {
                this.dropdownIsOpen = false;
                this.$refs.controllerResults.classList.remove('openResults')
            }
            

        },
        closeDropdown() {
            this.dropdownIsOpen = false;
            this.$refs.controllerResults.classList.remove('openResults')
        },
        changePic(controller)  {
            this.previewNo = controller.productNo
        },
        customCurrentChanged() {
            if(this.customDaliPower < 1) {
                this.customDaliPower = 1;
            }
            if(this.customDaliPower > 250) {
                this.customDaliPower = 250
            }
        },
        buildSelectableDevice() {
            if(!this.getSelectedPowerSupplies) {
                return
            }
            this.dropdownItems= []
            for(let controller of this.getSelectedPowerSupplies) {
                const item = new ImageDropdownItem()
                //console.log(controller)
                item.image = this.imagePath+ "productImages/" + controller.productNo + ".png";
                item.name = controller.productNo + " - " + controller.productName
                item.originalObject = controller
                item.clickEvent = (element) => {
                    this.selectSystemCard(element.originalObject)
                }
                this.dropdownItems.push(item)
            }
        }
    },
    computed: {
        ...mapGetters({
            allApplicationController: 'product/getAllApplicationController',
            customController: 'product/getCustomController',
            imagePath: 'app/getImagePath',
            selectedApplicationController: 'product/getSelectedApplicationController'
        }),
        getSelectedPowerSupplies() {
            const controllerItems = helper.cloneItem(this.allApplicationController);
            if(this.selectedSystem.systemType === "compactSensor") {
                return controllerItems.filter(obj => (obj.dacoSingleMasterWork == true || obj.dacoMultiMasterWork == true) && obj.casambiWork == false)
            }
            if(this.selectedSystem.systemType === "casambi") {
                return controllerItems.filter(obj => (obj.casambiWork == true))
            }
            if(this.selectedSystem.systemType === "daliLink") {
                return controllerItems.filter(obj => (obj.daliLinkWork == true || obj.knxLinkGatewayWork == true))
            }
            if(this.selectedSystem.systemType === "knx") {
                return controllerItems.filter(obj => (obj.knxLinkGatewayWork == true && obj.systemCategory == "daliLinkKnx" && obj.systemCategory != "bms"))
            }

            if(this.selectedSystem.systemType === "bms") {
                return //controllerItems.filter(obj => (obj.productNo === "00000"))
            }
            return []            
        },
        isCustomPowerSupplyAllowed() {
            if(this.selectedSystem.systemType === "compactSensor") {
                return false
            }
            if(this.selectedSystem.systemType === "casambi") {
                return false
            }
            if(this.selectedSystem.systemType === "daliLink") {
                return false
            }   
            if(this.selectedSystem.systemType === "knx") {
                return false
            }              
            return true
        },
        getSystemPicture() {
            return this.imagePath+this.selectedSystem.image;
            //var images = require.context('../../assets/images/')
/*             return images(this.system.image) */
        },
        getPreviewPicture() {
            return this.imagePath+ "productImages/" + this.previewNo + ".png";
        }
    },
    components: {
        ApplicationControllerCardCustom,
        ImageDropdownTemplate
    },
    props: {
        selectedSystem: Object
    },
    watch: {
        selectedSystem() {
            this.buildSelectableDevice()
        }
    }
}
</script>

<style lang="scss" scoped>
    #selectDeviceContainer {
        width: 140px;
        position: absolute;
        top: -130px;
        left: 140px;
        z-index: 30;
        filter: drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.161));
    }

    
    .top-distance {
        margin-top: 100px;
    }


    @media (max-width: 768px) { 
        #selectDeviceContainer {
            left: 30px;
            top: -140px;
        }

        .top-distance {
        margin-top: 150px;
    }
    }

    img {
        border-radius: 10px;
        
    }

    #selectDeviceContainer img {
        background-color: white;
        padding: 10px;
    }

    .selectedSystemCardIcon {
      --fa-icon-size: 10rem;

        background-color: var(--color-white);
        border-radius: var(--border-radius-default);
      aspect-ratio: 1/1;
    }

    .selectedSystemCard {
        position: relative;
        top: 0;
        max-width: 140px;
    }
</style>